import React from 'react'
import FormulaButton from '../formulaButton'
import FilesForm from '../../container/filesForm'

export default class Documents extends React.Component {
    render() {
        return (
            <div>
                <FormulaButton label="Documents" iconName="files">
                    <FilesForm />
                </FormulaButton>
            </div>
        )
    }
}